import { createFeatureSelector } from '@ngrx/store';
import { DashboardState } from './dashboard.state';


export const selectDashboardState = createFeatureSelector<DashboardState>('dashboard');
